import React from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import { _SelectWrapper as SelectWrapper } from './Select.style';
import { _Label as Label } from '../../Styled/Label';
import { _FieldDescription as FieldDescription } from '../../Styled/FieldDescription';

export const Select = ({ id, props }) => {
  const { label, options, required, description } = props;
  const optionsArray = options.split('\n');

  return (
    <SelectWrapper>
      <Label htmlFor={id}>{label}</Label>
      {description ? <FieldDescription>{description}</FieldDescription> : ''}
      <Field 
        as='select' 
        id={id} 
        name={`form['${label}']`} 
        required={required}
      >
        {optionsArray.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </Field>
    </SelectWrapper>
  );
};

Select.propTypes = {
  id: PropTypes.string.isRequired,
  props: PropTypes.shape({
    label: PropTypes.string.isRequired,
    options: PropTypes.string.isRequired,
    required: PropTypes.bool,
    name: PropTypes.string,
  }).isRequired,
};
